type AdminLineChartTooltipPayloadItem = {
  dataKey?: string;
  name?: string;
  value?: number | string;
}

type AdminLineChartTooltipProps = {
  active?: boolean;
  label?: string | number;
  payload?: AdminLineChartTooltipPayloadItem[];
}

const tooltipDotClassNameBySeries: Record<string, string> = {
  views: "bg-whatsapp",
  searches: "bg-brand-slate",
}

const getSeriesKey = (item: AdminLineChartTooltipPayloadItem) => {
  return String(item.dataKey || item.name || "").toLowerCase()
}

const formatTooltipValue = (value: number | string | undefined) => {
  if (typeof value === "number") {
    return new Intl.NumberFormat("en-US").format(value)
  }

  return value ?? ""
}

const AdminLineChartTooltip = ({
  active,
  label,
  payload,
}: AdminLineChartTooltipProps) => {
  if (!active || !payload?.length) {
    return null
  }

  return (
    <div className="min-w-[10rem] rounded-2xl border border-slate-200 bg-white px-3 py-2 shadow-lg">
      {label ? <p className="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-slate-500">{label}</p> : null}
      <div className="space-y-1.5">
        {payload.map((item) => {
          const seriesKey = getSeriesKey(item)
          const dotClassName = tooltipDotClassNameBySeries[seriesKey] || "bg-slate-400"

          return (
            <div key={`${seriesKey}-${item.value}`} className="flex items-center justify-between gap-3 text-sm">
              <div className="flex items-center gap-2 text-slate-600">
                <span className={`h-2.5 w-2.5 rounded-full ${dotClassName}`} />
                <span className="capitalize">{item.name || item.dataKey || "Value"}</span>
              </div>
              <span className="font-semibold text-slate-900">{formatTooltipValue(item.value)}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AdminLineChartTooltip